import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';

const propTypes = { onUpgrade: PropTypes.func.isRequired };

const DiamondUpgradeButton = ({ onUpgrade }) => {
  return (
    <Button
      btnStyle="reset"
      onClick={onUpgrade}
      className="ml-auto btn-label-upgrade"
    >
      <img width="16px" src={getAsset('/diamond-orange.svg')} alt="plan logo" />
    </Button>
  );
};

DiamondUpgradeButton.propTypes = propTypes;

export default DiamondUpgradeButton;
